import React, { useMemo } from 'react';

import omit from 'lodash/omit';

import {
  useCreative,
  useCreativeDetails,
  useUpdate,
  useIsUpdating,
} from 'scenes/Gallery/GalleryPage/Creatives/data';
import * as VIEW_CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import EditCreativeForm from './EditCreativeForm';
import { getValidationSchema } from './schemas';

const EditCreative = ({ id, onSubmit, onClose, open, onExited }) => {
  const { data, isLoading: isLoadingCreative } = useCreative({ id });
  const { data: detail, isLoading: isLoadingCreativeDetails } =
    useCreativeDetails({ id });
  const {
    isAllowDesigner,
    isAllowRequestedBy,
    isAllowJiraTask,
    isAllowTested,
    isAllowProductionType,
  } = useGalleryPermissions();
  const [updateCreative] = useUpdate();
  const isUpdating = useIsUpdating();
  const handleSubmit = async (values) => {
    const saveValues = omit(values, [
      VIEW_CREATIVE.FILE,
      VIEW_CREATIVE.NAME,
      VIEW_CREATIVE.SHORT_NAME,
    ]);
    await updateCreative(saveValues);
    onSubmit();
  };
  const merged = useMemo(() => {
    if (!data || !detail) {
      return;
    }
    return {
      ...data,
      [VIEW_CREATIVE.FILE]: detail[VIEW_CREATIVE.FILE],
      [VIEW_CREATIVE.NAME]: detail[VIEW_CREATIVE.NAME],
      [VIEW_CREATIVE.SHORT_NAME]: detail[VIEW_CREATIVE.SHORT_NAME],
    };
  }, [data, detail]);

  return (
    <EditCreativeForm
      loading={isLoadingCreative || isLoadingCreativeDetails || isUpdating}
      validationSchema={getValidationSchema({
        isAllowDesigner,
        isAllowRequestedBy,
        isAllowJiraTask,
        isAllowTested,
        isAllowProductionType,
      })}
      entityId={id}
      onClose={onClose}
      active={!!merged}
      initialValues={merged}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export default EditCreative;
